import React from 'react';
import PropTypes from 'prop-types';

import { FORM_TYPES } from './../../constants';
import VirtualDeviceConfigsListItem from './VirtualDeviceConfigsListItem';
import BrowserConfigsListItem from './BrowserConfigsListItem';
import RealDeviceConfigsListItem from './RealDeviceConfigsListItem';
import ConfigsListItemWrapper from './ConfigsListItemWrapper';

const ConfigsListItem = ({
  browserConfiguration,
  deviceConfiguration,
  formType,
  mobileAppConfiguration,
  onClick,
  virtualDeviceConfiguration,
  url,
}) => {
  if (formType === FORM_TYPES.REAL_DEVICE) {
    const osName = deviceConfiguration.os === 'IOS' ? 'iOS' : 'Android';

    return (
      <ConfigsListItemWrapper onClick={onClick}>
        <RealDeviceConfigsListItem
          {...deviceConfiguration}
          osName={osName}
          title={url}
        />
      </ConfigsListItemWrapper>
    );
  }

  if (formType === FORM_TYPES.MOBILE_APP) {
    const osName = deviceConfiguration.os === 'IOS' ? 'iOS' : 'Android';

    return (
      <ConfigsListItemWrapper onClick={onClick}>
        <RealDeviceConfigsListItem
          {...deviceConfiguration}
          osName={osName}
          title={mobileAppConfiguration.displayName}
        />
      </ConfigsListItemWrapper>
    );
  }

  if (formType === FORM_TYPES.VIRTUAL_DEVICE) {
    return (
      <ConfigsListItemWrapper onClick={onClick}>
        <VirtualDeviceConfigsListItem
          {...virtualDeviceConfiguration}
          url={url}
        />
      </ConfigsListItemWrapper>
    );
  }

  if (formType === FORM_TYPES.DESKTOP_BROWSER) {
    return (
      <ConfigsListItemWrapper onClick={onClick}>
        <BrowserConfigsListItem
          {...browserConfiguration}
          url={url}
        />
      </ConfigsListItemWrapper>
    );
  }

  return null;
};

ConfigsListItem.propTypes = {
  browserConfiguration: PropTypes.object,
  deviceConfiguration: PropTypes.object,
  formType: PropTypes.string,
  mobileAppConfiguration: PropTypes.object,
  onClick: PropTypes.func,
  url: PropTypes.string,
  virtualDeviceConfiguration: PropTypes.object,
};

ConfigsListItem.defaultProps = {
  browserConfiguration: null,
  deviceConfiguration: null,
  formType: null,
  mobileAppConfiguration: null,
  onClick: null,
  url: '',
  virtualDeviceConfiguration: null,
};

export default ConfigsListItem;
